<template>
  <div>
    <transition name="fade"
                mode="out-in"
    >
      <router-view
        v-if="ready"
      >

      </router-view>
    </transition>
  </div>
</template>

<style scoped>

</style>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'App',
    data() {
      return {};
    },
    watch: {
      'user.locales'(value) {
        if (value) {
          this.$i18n.locale = value;
        }
      },
    },
    computed: {
      ...mapGetters({
        ready: 'user/ready',
        user: 'user/user',
      }),
    },
    methods: {
      ...mapActions({
        fetch: 'user/fetch',
      }),
      ...mapMutations('app', ['toggleDrawer']),
    },
    mounted() {
      this.fetch();
    },
    components: {},
  };
</script>

